import { ISettings } from '@fluentui/react';
import { ButtonStyles } from './Button.styles';
import { CheckStyles } from './Check.styles';
import { CheckboxStyles } from './Checkbox.styles';
import { ChoiceGroupOptionStyles } from './ChoiceGroupOption.styles';
import { DefaultButtonStyles } from './DefaultButton.styles';
import { DetailsRowCheckStyles } from './DetailRowCheck.styles';
import { DetailsColumnStyles } from './DetailsListColumn.styles';
import { DetailsRowStyles } from './DetailsRow.styles';
import { DialogFooterStyles } from './DialogFooter.styles';
import { OverlayStyles } from './Overlay.styles';
import { PanelStyles } from './Panel.styles';
import { PrimaryButtonStyles } from './PrimaryButton.styles';
import { SearchBoxStyles } from './SearchBox.styles';
import { SpinnerStyles } from './Spinner.styles';
// import { PivotStyles } from './Pivot.styles';

export const M365Styles: { [key: string]: ISettings } = {
  ActionButton: { styles: DefaultButtonStyles },
  Button: { styles: ButtonStyles },
  Check: { styles: CheckStyles },
  Checkbox: { styles: CheckboxStyles },
  ChoiceGroupOption: { styles: ChoiceGroupOptionStyles },
  CommandBarButton: { styles: DefaultButtonStyles },
  CompoundButton: { styles: DefaultButtonStyles },
  DefaultButton: { styles: DefaultButtonStyles },
  DetailsColumn: { styles: DetailsColumnStyles },
  DetailsRow: { styles: DetailsRowStyles },
  DetailsRowCheck: { styles: DetailsRowCheckStyles },
  DialogFooter: { styles: DialogFooterStyles },
  Overlay: { styles: OverlayStyles },
  Panel: { styles: PanelStyles },
  PrimaryButton: { styles: PrimaryButtonStyles },
  SearchBox: { styles: SearchBoxStyles },
  Spinner: { styles: SpinnerStyles },
};
